"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPurchaseOriginsMetaData = getPurchaseOriginsMetaData;
var _analyticsData = require("@ori/analytics-data");
var _logger = require("../logger");
/**
 * Current URL lookup settings ordered from most specific searchedText values.
 * Same uriTemplate can be set for multiple searchedText values, thus making
 * a group of pages being treated as the same purchase origin.
 * When the uriTemplate is not provided, the searchedText will be used instead.
 */
const settings = [{
  searchedText: '/order/manage-subscriptions',
  placement: ''
}, {
  searchedText: '/products/product',
  placement: _analyticsData.Placement.FloatingMenu
}, {
  searchedText: '/shopping/basket',
  placement: _analyticsData.Placement.SubscriptionButton
}];

/**
 * @returns Metadata to be sent as HTTP headers in user action requests to server.
 * So although the placement is primarily used for analytics, here we use it to determine the purchase origin.
 * Purchase origins are resolved based on database data & it is critical info for business.
 * When doing changes in this method, corresponging changes should be done in the DB.
 */
function getPurchaseOriginsMetaData(path) {
  for (const {
    searchedText,
    placement,
    uriTemplate
  } of settings) {
    if (path.includes(searchedText)) {
      return {
        placement,
        uriTemplate: uriTemplate ?? searchedText
      };
    }
  }
  (0, _logger.logWarning)('No matching purchase origins matadata was found & the default was used for path:', path);
  return {
    placement: _analyticsData.Placement.FloatingMenu,
    uriTemplate: path
  };
}
